module.exports = __webpack_public_path__ + "img/offline-big.06901a6b.svg";